module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small button-group"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.facebook,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" SHARE")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.twitter,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-twitter"
  }), _vm._v(" SHARE")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.linkedIn,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-linkedin"
  }), _vm._v(" SHARE")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d47596c!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/ShareButtons.vue
// module id = 413
// module chunks = 0